import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {
    addUserForm: FormGroup;
    franchiseIdList: any[] = [];
    userStatusList: any[] = [];
    isLoading: boolean = false;
    currentUser: any;
    isEdit: boolean = false;
    userData: any = [];
    statusMap: {};
    statusIdMap: {};
    app: any;
    status: any;
    constructor(
        private dialog: MatDialog,
        private http: HttpClient,
        private generalService: GeneralService,
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<AddUserComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router
    ) {}

    ngOnInit() {
        this.currentUser = this.generalService.getcurrentUser();
        let franchiseId = null;
        if (this.currentUser.franchise_Id) {
            franchiseId = this.currentUser.franchise_Id;
        }
        this.addUserForm = this.fb.group({
            FirstName: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(60),
                    Validators.pattern(/^[a-zA-Z ]+$/),
                ],
            ],
            LastName: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(60),
                    Validators.pattern(/^[a-zA-Z ]+$/),
                ],
            ],
            Email: ['', [this.multiEmailValidator]],
            MobileNo: ['', [Validators.required, this.multiMobileValidator]],
            Address: ['', [Validators.maxLength(255)]],
            franchise_Id: [franchiseId],
        });
        console.log('msncmsdnvmsndvs', this.data);
        if (this.data.userData || this.data.app) {
            console.log(this.data.userData, 'dataApp');
            this.getStatusList();
            this.isEdit = this.data.isEdit;
            console.log(this.isEdit, '............isEdit');
            this.getFranchiseIds();
            this.userData = this.data.userData;
            this.app = this.data.app;
            console.log('dkvs', this.data.app);
            // console.log("App",this.app[0].Username)
            this.addUserForm.addControl(
                'UserStatusId',
                this.fb.control(null, Validators.required)
            );
            this.addUserForm.addControl(
                'Newusername',
                this.fb.control(null, [
                    Validators.minLength(10),
                    Validators.maxLength(10),
                ])
            );
            this.addUserForm.addControl('App', this.fb.control(null));
            if (this.app.Username === null) {
                this.addUserForm.addControl('Username', this.fb.control(null));
            } else {
                this.addUserForm.addControl(
                    'Username',
                    this.fb.control(null, Validators.required)
                );
            }
        }
    }

    multiMobileValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!value) return null;

        const numbers = value.split(',').map((num) => num.trim());

        const invalid = numbers.some((num) => !/^\d{10}$/.test(num));

        return invalid ? { multiMobileInvalid: true } : null;
    }

    multiEmailValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!value) return null;

        const emails = value.split(',').map((email) => email.trim());

        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        const invalid = emails.some((email) => !emailPattern.test(email));

        return invalid ? { multiEmailInvalid: true } : null;
    }

    close() {
        // this.dialog.closeAll();
        this.dialogRef.close(false);
        this.addUserForm.reset();
        console.log('this.adduserform', this.addUserForm);
    }

    addUser() {
        this.trimFormValues(this.addUserForm);
        console.log('control', this.addUserForm.controls);
        this.isLoading = true;
        if (this.isEdit) {
            let userid = localStorage.getItem('UserId');
            let obj = { id: userid, status: this.status, UserID: userid };
            if (this.addUserForm.controls.franchise_Id.value === 0) {
                this.addUserForm.controls.franchise_Id.setValue(null);
            }
            if (this.addUserForm.controls.Newusername.value !== null) {
                this.addUserForm.controls.Username.clearValidators();
                this.addUserForm.controls.UserStatusId.clearValidators();
                this.addUserForm.controls.LastName.clearValidators();
                this.addUserForm.controls.FirstName.clearValidators();
                this.addUserForm.controls.MobileNo.clearValidators();
                this.addUserForm.controls.Email.clearValidators();
                this.addUserForm.controls.Address.clearValidators();
                this.addUserForm.controls.franchise_Id.clearValidators();
                this.addUserForm.controls.App.clearValidators();
                this.addUserForm.removeControl('Username');
                this.addUserForm.removeControl('UserStatusId');
                this.addUserForm.removeControl('LastName');
                this.addUserForm.removeControl('FirstName');
                this.addUserForm.removeControl('MobileNo');
                this.addUserForm.removeControl('Email');
                this.addUserForm.removeControl('Address');
                this.addUserForm.removeControl('franchise_Id');
                this.addUserForm.removeControl('App');
                this.addUserForm.addControl('UserID', this.fb.control(userid));
                this.generalService
                    .newMobile(this.addUserForm.value)
                    .subscribe((res: any) => {
                        if (res.status === 200) {
                            Swal.fire({
                                text: res.message,
                                type: 'success',
                                timer: 1500,
                                showConfirmButton: false,
                            });
                            this.dialogRef.close(true);
                            // list refresh is handled by the parent dialog (afterClosed -> rerender); no full page reload
                        }
                        if (res.status === 404) {
                            Swal.fire({
                                text: res.message,
                                type: 'info',
                                timer: 1500,
                                showConfirmButton: false,
                            });
                            this.dialogRef.close(true);
                        }
                        if (res.status === 400) {
                            Swal.fire({
                                text: res.message,
                                type: 'info',
                                timer: 1500,
                                showConfirmButton: false,
                            });
                            this.dialogRef.close(true);
                        }
                    });
                console.log('controls', this.addUserForm.controls);
            } else {
                this.addUserForm.removeControl('Newusername');
                this.generalService
                    .updateFranchiseUser(
                        Object.assign(this.addUserForm.value, obj)
                    )
                    .subscribe(
                        (res: any) => {
                            if (res.status === 200) {
                                Swal.fire({
                                    title: 'User details updated',
                                    text: res.message,
                                    type: 'success',
                                    timer: 1500,
                                    showConfirmButton: false,
                                });
                                this.isLoading = false;
                                this.dialogRef.close(true);
                                this.addUserForm.reset();
                                // list refresh is handled by the parent dialog (afterClosed -> rerender); no full page reload
                            } else if (res.status === 412) {
                                // this.dialog.closeAll();
                                this.dialogRef.close(true);
                                this.addUserForm.reset();
                                Swal.fire({
                                    title: 'Failed to update user',
                                    text: res.error,
                                    type: 'error',
                                    timer: 1500,
                                    showConfirmButton: false,
                                });
                                this.isLoading = false;
                            }
                        },
                        (error) => {
                            this.isLoading = false;
                            Swal.fire({
                                title: error.status,
                                text: 'Internal Server Error',
                                type: 'error',
                                timer: 1500,
                                showConfirmButton: false,
                            });
                            this.dialogRef.close(false);
                        }
                    );
            }
        } else {
            this.generalService
                .addFranchiseUser(this.addUserForm.value)
                .subscribe(
                    (res: any) => {
                        if (res.status === 200) {
                            Swal.fire({
                                title: 'User Added',
                                text: res.message,
                                type: 'success',
                                timer: 1500,
                                showConfirmButton: false,
                            });
                            this.isLoading = false;
                            this.dialogRef.close(true);
                            this.addUserForm.reset();
                            // list refresh is handled by the parent dialog (afterClosed -> rerender); no full page reload
                        } else if (res.status === 412) {
                            // this.dialog.closeAll();
                            this.dialogRef.close(true);
                            this.addUserForm.reset();
                            Swal.fire({
                                title: 'Failed to add user',
                                text: res.error,
                                type: 'error',
                                timer: 1500,
                                showConfirmButton: false,
                            });
                            this.isLoading = false;
                        }
                    },
                    (error) => {
                        this.isLoading = false;
                        Swal.fire({
                            title: error.status,
                            text: 'Internal Server Error',
                            type: 'error',
                            timer: 1500,
                            showConfirmButton: false,
                        });
                        this.dialogRef.close(false);
                    }
                );
        }
    }

    stausChange(event: any) {
        if (event.value) {
            this.status = this.statusIdMap[event.value];
        }
    }
    getFranchiseIds() {
        this.isLoading = true;
        this.generalService.getFranchiseId().subscribe(
            (res: any) => {
                if (res) {
                    this.franchiseIdList = res.data;
                    this.isLoading = false;
                }
            },
            (error) => {
                this.isLoading = false;
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        );
    }

    trimValue(key: any) {
        this.addUserForm.controls[key].setValue(
            this.addUserForm.controls[key].value.trim()
        );
    }

    phoneno(event: any) {
        var arr = [];
        var kk = event.which;
        for (let i = 48; i < 58; i++) {
            arr.push(i);
        }
        if (!(arr.indexOf(kk) >= 0)) {
            event.preventDefault();
        }
    }

    isValid(event) {
        const key = event.key;
        const input = event.target.value;

        // Allow control keys like Backspace, Delete, Arrow keys
        if (
            key === 'Backspace' ||
            key === 'Delete' ||
            key === 'ArrowLeft' ||
            key === 'ArrowRight' ||
            key === 'Tab'
        ) {
            return true;
        }

        // Allow comma to separate numbers
        if (key === ',') {
            // Prevent consecutive commas or comma at start
            if (input.endsWith(',') || input.length === 0) {
                event.preventDefault();
                return false;
            }

            // Validate current segment is exactly 10 digits before allowing comma
            const segments = input.split(',');
            const lastSegment = segments[segments.length - 1];
            if (lastSegment.length !== 10 || /\D/.test(lastSegment)) {
                event.preventDefault();
                return false;
            }

            return true;
        }

        // Allow digits only
        if (/^\d$/.test(key)) {
            const segments = input.split(',');
            const lastSegment = segments[segments.length - 1] || '';
            if (lastSegment.length >= 10) {
                event.preventDefault();
                return false;
            }
            return true;
        }

        // Block everything else
        event.preventDefault();
        return false;
    }

    getStatusList() {
        console.log('kdnvkdsn');
        this.isLoading = true;
        this.generalService.getUsersStatusList().subscribe(
            (res: any) => {
                console.log('respinse', res);
                if (res) {
                    this.userStatusList = res.data;
                    this.isLoading = false;
                    this.statusMap = {};
                    this.statusIdMap = {};
                    this.userStatusList.forEach((i) => {
                        this.statusMap[i.Status.toLowerCase().trim()] =
                            i.UserStatusId;
                        this.statusIdMap[i.UserStatusId] =
                            i.Status.toLowerCase().trim();
                    });
                    this.setUserData();
                }
            },
            (error) => {
                this.isLoading = false;
                Swal.fire({
                    title: error.status,
                    text: 'Failed to get Users status list',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        );
    }
    setUserData() {
        this.status = this.userData.Status;
        console.log(this.status, 'Status');

        this.addUserForm.controls.FirstName.setValue(this.userData.FirstName);
        this.addUserForm.controls.LastName.setValue(this.userData.LastName);
        this.addUserForm.controls.Email.setValue(this.userData.EmailID);
        this.addUserForm.controls.Address.setValue(this.userData.Address);
        this.addUserForm.controls.MobileNo.setValue(this.userData.MobileNo);

        if (this.app === null) {
            this.addUserForm.controls.App.setValue('no');
        } else {
            console.log('app', this.app);
            console.log('controls', this.addUserForm.controls);

            let usernameValue = '';
            if (this.app.CombinedUsernames !== null) {
                usernameValue =
                    this.app +
                    (this.app.CombinedUsernames
                        ? ',' + this.app.CombinedUsernames
                        : '');
            } else {
                usernameValue = this.app;
            }

            // Set the value and keep control disabled
            this.addUserForm.controls.Username.setValue(usernameValue);
            this.addUserForm.controls.Username.disable(); // Explicitly disable it again here

            this.addUserForm.controls.App.setValue('yes');
        }

        this.addUserForm.controls.franchise_Id.setValue(
            this.userData.franchise_Id
        );

        let normalizedStatus = '';
        if (this.userData.Status) {
            normalizedStatus = this.userData.Status.toLowerCase().trim();
            this.addUserForm.controls.UserStatusId.setValue(
                this.statusMap[normalizedStatus]
            );
        } else {
            console.warn('User status is missing or undefined.');
        }

        console.log(this.statusMap, 'Status Map');
    }
    trimFormValues(form: FormGroup): void {
        Object.keys(form.controls).forEach((key) => {
            const control = form.get(key);
            if (control && typeof control.value === 'string') {
                control.setValue(control.value.trim());
            }
        });
    }
}
